

<div dwRow>
    <div dwCol="12">
        <label class="label">Checkride Date/Time</label><br>
        {{selectedDateTimeFormatted}}
    </div>
</div>